$(() => {
    const dataPickers = document.querySelectorAll('.data-picker');

    dataPickers.forEach((dataPicker) => {
        initDatePicker(dataPicker);
    })

    function initDatePicker(input) {
        if (input.getAttribute('data-init')) {
            return false;
        }

        input.setAttribute('data-init', true);

        const minDate = input.getAttribute('min');
        const maxDate = input.getAttribute('max');
        let [start, end] = input.value.split(' - ');
        const startDate = new Date(start);
        const endDate = new Date(end);

        const instance = new AirDatepicker(input, {
            range: true,
            toggleSelected: false,
            multipleDatesSeparator: ' - ',
            // dateFormat: 'dd.MM.yyyy',
            multipleDates: true,
            minDate: minDate ? minDate : '',
            maxDate: maxDate ? maxDate : '',
            dateFormat([startDate, endDate]) {
                if (!endDate || startDate.toLocaleDateString("ru-RU") === endDate.toLocaleDateString("ru-RU")) {
                    return `${startDate.toLocaleDateString("ru-RU")}`
                }
                return `${startDate.toLocaleDateString("ru-RU")} - ${endDate.toLocaleDateString("ru-RU")}`
            },
            onSelect({date}) {
                const [startDate, endDate] = date;
                if (startDate && endDate) {
                    const changeEvent = new Event('change');
                    input.dispatchEvent(changeEvent);
                }
            }
        })

        instance.selectDate([startDate, endDate], {
            silent: true
        })
    }

    window.initDatePicker = initDatePicker;
})


